import React from 'react';


import "./Background.scss";

function Background () {
  return (
    <section className="Background" />
  );
}

export default Background;
